import * as yup from "yup";

export const nhmApplicantsSchema = yup.object().shape({
  satbaraDoc: yup.string(),
  utaraDoc: yup.string(),
  castDoc: yup.string(),
  certiDoc: yup.string(),
  studyDoc: yup.string(),
  tenDate: yup.string().required("संभाव्य प्रारंभ दिनांक आवश्यक आहे"),
  bankLoan: yup.string().required("बँक कर्जासाठी आवश्यक आहे"),
  Name: yup.string(),
  Mobile: yup.string(),
  Village: yup.string(),
  Taluka: yup.string(),
  District: yup.string(),
  Component: yup.string(),
  Structure: yup.string(),
  Area: yup.string(),
  System: yup.string(),
  TubularStructure: yup.string(),
  code: yup.string(),
  type: yup.string().nullable(),
  typeCode: yup.string(),
  size: yup.string(),
  areaSqM: yup.string(),
  subsidyPercent: yup.string(),
  maxSubsidyRs: yup.string(),
});
